// extracted by mini-css-extract-plugin
export default {"home":"Home_home__6fkPt","themeLink":"Home_themeLink__FZodz"};